import { Observable } from 'rxjs';

import { Models, ModelsCreateParams, ModelsExtract, ModelsExtractParams } from '../models/model.model';

export abstract class ModelUsecase {
  abstract get models$(): Observable<Models>;
  abstract get extractModels$(): Observable<ModelsExtract[]>;

  abstract listModels(): Observable<never>;
  abstract listExtractModels(params: ModelsExtractParams): Observable<never>;
  abstract createModels(params: ModelsCreateParams): Observable<never>;
  abstract deleteModel(modelId: string): Observable<never>;
}
